export default function isChunkLoadError(error) {
    return (error === null || error === void 0 ? void 0 : error.name) === "ChunkLoadError";
}
//# sourceMappingURL=isChunkLoadError.js.map